import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LEGISLATION_FILES, LegislationFileDescriptor } from './legislation-files';

@Component({
  selector: 'app-legislation',
  templateUrl: './legislation.component.html',
  styleUrls: ['./legislation.component.sass'],
})
export class LegislationComponent implements OnInit {
  constructor(private router: Router) {}

  columns: LegislationFileDescriptor[][] = [];

  ngOnInit(): void {
    this.buildColumns();
  }

  @HostListener('window:resize')
  onResize(): void {
    this.buildColumns();
  }

  private buildColumns(): void {
    const size = this.getColumnSize();
    const gridItems = LEGISLATION_FILES.slice(0, this.getMaxItems());
    this.columns = [];
    for (let i = 0; i < gridItems.length; i += size) {
      this.columns.push(gridItems.slice(i, i + size));
    }
  }

  private getMaxItems(): number {
    const width = window.innerWidth;
    if (width < 640) return 6;
    if (width < 1024) return 8;
    return 10;
  }

  private getColumnSize(): number {
    const width = window.innerWidth;
    if (width >= 1024) return 6;
    if (width >= 768) return 5;
    return 4;
  }

  downloadByItem(item: LegislationFileDescriptor): void {
    this.download(item.fileName);
  }

  onItemKeydown(event: KeyboardEvent, item: LegislationFileDescriptor): void {
    const isActivationKey = event.key === 'Enter' || event.key === ' ';
    if (!isActivationKey) {
      return;
    }

    event.preventDefault();
    this.downloadByItem(item);
  }

  private download(fileName: string): void {
    const link = document.createElement('a');
    link.download = fileName;
    link.href = `assets/files/${fileName}`;
    link.click();
    link.remove();
  }
}
